import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ModalService } from 'app/services/modal.service';
import { BuscarVeiculoContratoArrendamentoComponent } from '../../veiculo/buscar-veiculo/buscar-veiculo-contrato-arrendamento.component';
import { ContratoArrendamento } from 'app/models/arrendamento/contrato-arrendamento.model';
import { VeiculoSimples } from 'app/models/arrendamento/veiculo-simples.model';
import { CpfCnpjPipe } from 'app/shared/pipes/cpfCnpj.pipe';
import * as moment from 'moment';
import { NgForm } from '@angular/forms';
import { ContratoArrendamentoService } from 'app/services/contrato-arrendamento.service';
import { DocumentoService } from 'app/services/documento.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-modal-ajuste-contrato-arrendamento',
  templateUrl: './modal-ajuste-contrato-arrendamento.component.html',
  styleUrls: ['./modal-ajuste-contrato-arrendamento.component.css'],
  providers: [CpfCnpjPipe]
})
export class ModalAjusteContratoArrendamentoComponent implements OnInit, AfterViewInit  {
    @ViewChild('form', {static:  true})
    form: NgForm;

    @ViewChild('modalArrendamentoComponent', { static: true})
    public buscaVeiculoComponent: BuscarVeiculoContratoArrendamentoComponent;

    public id: number;
    public errors: string[] = [];
    public pedidoId: number | string;

    public contrato: ContratoArrendamento = {
        cienciaPena: false,
        contratoValido: false,
        cpfCnpjArrendatario: '',
        cpfCnpjArrendante: '',
        dataValidadeFim: '',
        dataValidadeInicio: '',
        nomeRazaoSocialArrendante: '',
        nomeRazaoSocialArrendatario: '',
        placa: '',
        renavam: ''
    }

    dataValidadeFim: any = {};
    dataValidadeInicio: any = {};
    showFileSelection = true;
    dataMinimaValida: Date = new Date(1900, 0, 1); // 01/01/1900
    dataMaximaValida: Date = new Date(); // data atual

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        public dialogRef: MatDialogRef<ModalAjusteContratoArrendamentoComponent>,
        private contratoArrendamentoService: ContratoArrendamentoService,
        private documentoService: DocumentoService,
        private modalService: ModalService,
        private cpfCnpjPipe: CpfCnpjPipe,
    ) { }

    public ngAfterViewInit(): void { 
        this.pedidoId = this.data.pedidoId;
        if (this.pedidoId && this.pedidoId !== '') {
            this.contratoArrendamentoService.getContratoPorPedidoId(this.pedidoId.toString()).subscribe(result => {
                if (result) {
                    this.contrato = result;
                    this.buscaVeiculoComponent.valorPesquisa = result.placa.toUpperCase();
                    
                    this.form.controls["dataInicio"].setValue(`${moment(result.dataValidadeInicio, "DD/MM/YYYY").format('YYYY-MM-DD HH:mm:ss')}`);
                    this.form.controls["dataFim"].setValue(`${moment(result.dataValidadeFim, "DD/MM/YYYY").format('YYYY-MM-DD HH:mm:ss')}`);
                    this.contrato.cpfCnpjArrendante = this.cpfCnpjPipe.transform(this.contrato.cpfCnpjArrendante);
                    this.contrato.cpfCnpjArrendatario = this.cpfCnpjPipe.transform(this.contrato.cpfCnpjArrendatario);
                }
            });
        }
    }
  
    close() {
       this.dialogRef.close();
    }

    ngOnInit(): void {
      setTimeout(() => {
       this.limparFormulario();    
      });
    }

    onVeiculoChangeHandler(veiculo: VeiculoSimples) {
        this.contrato.placa = veiculo.placa;
        this.contrato.renavam = veiculo.renavam;
        this.contrato.cpfCnpjArrendante = this.cpfCnpjPipe.transform(veiculo.cpfCnpjArrendante);
        this.contrato.nomeRazaoSocialArrendante = veiculo.nomeArrendante;
    }

    onCpfCnpjChangeHandler(cpfCnpj: string, field = '') {
        this.contrato[field] = cpfCnpj;
    }

    atualizarContrato() {
        const contrato: ContratoArrendamento = {
            placa: this.buscaVeiculoComponent.valorPesquisa,
            renavam: this.contrato.renavam,
            cienciaPena: this.contrato.cienciaPena,
            contratoValido: this.contrato.contratoValido,
            dataValidadeFim: this._dateFormatter(this.dataValidadeFim),
            dataValidadeInicio: this._dateFormatter(this.dataValidadeInicio),
            nomeRazaoSocialArrendante: this.contrato.nomeRazaoSocialArrendante,
            nomeRazaoSocialArrendatario: this.contrato.nomeRazaoSocialArrendatario,
            cpfCnpjArrendante: (this.contrato.cpfCnpjArrendante ? this.contrato.cpfCnpjArrendante.replace(/[^0-9]+/g, '') : null),
            cpfCnpjArrendatario: (this.contrato.cpfCnpjArrendatario ? this.contrato.cpfCnpjArrendatario.replace(/[^0-9]+/g, '') : null)
        }

        this.contratoArrendamentoService.atualizarContrato(this.pedidoId.toString(), contrato).subscribe(
            result => {    
                if (result) {
                    this.modalService.success('Contrato arrendamento atualizado com sucesso.');
                    this.dialogRef.close(true);
                }
                else {
                    this.modalService.success('O Contrato arrendamento não foi atualizado. Tente novamente.');
                }                    
            },
            error => {
                 if (error.status === 500) {
                      this.modalService.error('Ocorreu um erro interno no servidor. Tente novamente mais tarde.');
                    return;
                 }

                if (error.error.errors[0].message.length) {
                    this.modalService.error(error.error.errors[0].message);
                } else {
                    this.modalService.error(error.error.message);
                }
            }
        );
    }


    desabilitarBotaoIncluir() {
        let naoHabilita = false;

        if (this.form.invalid) naoHabilita = true;
        if (this.buscaVeiculoComponent.valorPesquisa.trim().length < 7) naoHabilita = true;
        if ((this.contrato.cpfCnpjArrendante) && (this.contrato.cpfCnpjArrendante.length < 14)) naoHabilita = true;
        if ((this.contrato.cpfCnpjArrendante) && (this.contrato.cpfCnpjArrendante.length > 14 && this.contrato.cpfCnpjArrendante.length < 18)) naoHabilita = true;
        if ((this.contrato.cpfCnpjArrendatario) && (this.contrato.cpfCnpjArrendatario.length < 14)) naoHabilita = true;
        if ((this.contrato.cpfCnpjArrendatario) && (this.contrato.cpfCnpjArrendatario.length > 14 && this.contrato.cpfCnpjArrendatario.length < 18)) naoHabilita = true;
        if ((this.contrato.nomeRazaoSocialArrendante) && (this.contrato.nomeRazaoSocialArrendante.length < 2)) naoHabilita = true;
        if ((this.contrato.nomeRazaoSocialArrendatario) && (this.contrato.nomeRazaoSocialArrendatario.length < 2)) naoHabilita = true;
        if (this.dataValidadeInicio === null || this.dataValidadeFim === null) naoHabilita = true;
        this.validarDatas();
               
        return naoHabilita;
    }

    limparFormulario() {
        this.buscaVeiculoComponent.valorPesquisa = '';

        this.form.control.reset();
        this.form.control.markAsUntouched();

        Object.keys(this.form.control.controls).forEach(name => {
            const control = this.form.control.controls[name];

            control.setErrors(null);
        })
    }

    maxDateChangeHandler() {
        this.outFocusDate();
    }

    minDateChangeHandler() {
        this.outFocusDate();
    }

    private _dateFormatter(value: any): string {
        return `${moment(value).format('YYYY-MM-DD HH:mm:ss')}`;
    }

    validateDate() {
        this.form.controls["dataFim"].setErrors(null);

        if (this.isDateInitialBigger()) {
            this.form.controls["dataFim"].setErrors({ 'erroDataMenorInicio': true});
            this.form.controls["dataFim"].markAsTouched();
        } 
        
        this.form.control.updateValueAndValidity();
    }

    outFocusDate() {
        this.validateDate();
        this.form.controls["dataInicio"].setErrors(null);

        if (
            this.form.controls["dataInicio"].value == null 
            || this.form.controls["dataInicio"].value == ''
            || Object.keys(this.form.controls["dataInicio"].value).length === 0
        ) {
            this.form.controls["dataInicio"].setErrors({ 'customError': true});
            this.form.controls["dataInicio"].markAsTouched();    
        }
        this.form.control.updateValueAndValidity();
    }

    isDateInitialBigger = (): boolean => (this.dataValidadeInicio != null && Object.keys(this.dataValidadeInicio).length !== 0)
         && (this.dataValidadeFim != null && Object.keys(this.dataValidadeFim).length !== 0)
         && moment(this.dataValidadeInicio).isSameOrAfter(moment(this.dataValidadeFim));

    isDateMinimaValida = (date: any): boolean => {
        const dataMinima = moment(this.dataMinimaValida);
        return moment(date).isBefore(dataMinima);
    }

    isDateMaximaValida = (date: any): boolean => {
        const dataMaxima = moment(this.dataMaximaValida);
        return moment(date).isAfter(dataMaxima);
    }

    validarDatas() {
        if (this.dataValidadeInicio != null && Object.keys(this.dataValidadeInicio).length !== 0) {
            if (this.isDateMinimaValida(this.dataValidadeInicio)) {
                this.form.controls["dataInicio"].setErrors({ 'dataInvalida': true});
                this.form.controls["dataInicio"].markAsTouched();    
            }
            if (this.isDateMaximaValida(this.dataValidadeInicio)) {
                this.form.controls["dataInicio"].setErrors({ 'dataInvalida': true});
                this.form.controls["dataInicio"].markAsTouched();    
            }
        }

        if (this.dataValidadeFim != null && Object.keys(this.dataValidadeFim).length !== 0) {
            if (this.isDateMinimaValida(this.dataValidadeFim)) {
                this.form.controls["dataFim"].setErrors({ 'dataInvalida': true});
                this.form.controls["dataFim"].markAsTouched();    
            }
        }
    }
}
